import {
  Body,
  Controller,
  Param,
  ParseIntPipe,
  Patch,
  UseGuards,
} from '@nestjs/common';
import { PatchProfileRequest } from '../models/patch-profile.request';
import { HasOwnerPermissionGuard } from '../guards/has-owner-permission-guard.service';
import { AuthenticatedUserResponse } from '@ip6m/server/shared';
import { UserDataService } from '@ip6m/server/data-access-user';
import { TokenService } from '@ip6m/server/auth';
import { ApiOkResponse, ApiOperation, ApiTags } from '@nestjs/swagger';

@Controller('profile')
@ApiTags('self care')
export class ProfileController {
  constructor(
    private userDataService: UserDataService,
    private tokenService: TokenService
  ) {}

  @Patch(':id')
  @UseGuards(HasOwnerPermissionGuard)
  @ApiOperation({
    operationId: 'patchProfile',
    description: 'Patch user profile.',
  })
  @ApiOkResponse({
    type: AuthenticatedUserResponse,
  })
  async patchProfile(
    @Param('id', ParseIntPipe) id: number,
    @Body() data: PatchProfileRequest
  ): Promise<AuthenticatedUserResponse> {
    const user = await this.userDataService.update(id, data);

    return new AuthenticatedUserResponse({
      idToken: this.tokenService.idTokenFromUser(user),
      accessToken: this.tokenService.accessTokenFromUserId(user.id),
    });
  }
}
